import React, { useState, useEffect } from 'react';
import { Users, BookOpen, Menu, GraduationCap, FileText } from 'lucide-react';
import '../styles/teacherDashboard.css';
import AddQuestionsForm from './postQuestion';
import TeacherPage from './stdntreg';
import AudioList from './audioList';
import FilterAndDownload from './FilterAndDownload';
import Dashboard from './studentdashbrd';
import { useNavigate, Link } from 'react-router-dom';

const TeacherDashboard = ({ toggleSidebar, isSidebarOpen }) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [studentCount, setStudentCount] = useState(0);
  const [quizCount, setQuizCount] = useState(0);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [studentsRes, quizRes] = await Promise.all([
          fetch('https://gnrl-bknd-server.onrender.com/api/users/count'),
          fetch('https://gnrl-bknd-server.onrender.com/api/quiz/count')
        ]);
        
        const studentsData = await studentsRes.json();
        const quizData = await quizRes.json();
        
        setStudentCount(studentsData.count);
        setQuizCount(quizData.count);
      } catch (error) {
        console.error('Error fetching counts:', error);
      }
    };

    fetchCounts();
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    const announcement = document.getElementById('tab-announcement');
    if (announcement) {
      announcement.textContent = `${tab} tab selected`;
    }
  };

  return (
    <div className="dashboard-container">
      <div 
        id="tab-announcement" 
        className="sr-only" 
        role="status" 
        aria-live="polite"
      ></div>

      <nav className="dashboard-nav" role="navigation" aria-label="Main navigation">
        <div className="nav-content">
          <div className="nav-logo">
            <button 
              className="mobile-menu-button"
              onClick={toggleSidebar}
              aria-label="Toggle menu"
            >
              <Menu className="icon" />
            </button>
            <img 
              src="/cmpnylogo.jpg" 
              alt="Company Logo" 
              className="company-logo"
            />
          </div>
          <div className="nav-title">
            <h1>Teacher Dashboard</h1>
          </div>
          <div className="nav-welcome">
            <span>Welcome, Teacher</span>
          </div>
        </div>
      </nav>

      <main className="dashboard-main">
        <div className="stats-grid">
          <div className="stat-card" role="region" aria-label="Student Statistics">
            <div className="stat-icon">
              <GraduationCap size={24} className="icon" />
            </div>
            <div className="stat-content">
              <h3>Total Students</h3>
              <div className="stat-value">
                <span className="stat-number">{studentCount}</span>
                <Users size={20} className="stat-indicator" />
              </div>
            </div>
          </div>

          <div className="stat-card" role="region" aria-label="Quiz Statistics">
            <div className="stat-icon">
              <FileText size={24} className="icon" />
            </div>
            <div className="stat-content">
              <h3>Total Quizzes</h3>
              <div className="stat-value">
                <span className="stat-number">{quizCount}</span>
                <BookOpen size={20} className="stat-indicator" />
              </div>
            </div>
          </div>
        </div>

        <div className="tabs-container">
          <div className="tabs-header" role="tablist">
            {['overview'].map((tab) => (
              <button
                key={tab}
                role="tab"
                aria-selected={activeTab === tab}
                aria-controls={`${tab}-panel`}
                id={`${tab}-tab`}
                className={`tab-button ${activeTab === tab ? 'active' : ''}`}
                onClick={() => handleTabChange(tab)}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>

          <div className="tab-content">
            <div 
              role="tabpanel"
              id="overview-panel"
              aria-labelledby="overview-tab"
              hidden={activeTab !== 'overview'}
            >
              {activeTab === 'overview' && <FilterAndDownload />}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TeacherDashboard;